document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".shop-slider").forEach((slider) => {
    const track = slider.querySelector(".shop-slider-track");
    const slides = slider.querySelectorAll("img");
    const prev = slider.querySelector(".prev");
    const next = slider.querySelector(".next");

    let index = 0;

    function updateSlider() {
      track.style.transform = `translateX(-${index * 100}%)`;
    }

    next?.addEventListener("click", () => {
      index = (index + 1) % slides.length;
      updateSlider();
    });

    prev?.addEventListener("click", () => {
      index = (index - 1 + slides.length) % slides.length;
      updateSlider();
    });
  });
});